<template>
  <table class="tableSize flipTable">
    <tr>
      <th class="tableHeader" v-for="(header, n) in headers" v-if="isMinter(n)" :key="n">{{campaignType !== 'PIP' ? header : header !== 'UV' ? header : 'SKIP'}}</th>
    </tr>
    <tbody>
      <tr v-for="(contract, index) in contractData" :key="index">
        <td>{{contract.ad_knd_nm}}</td>
        <!-- 광고상품 -->
        <td>{{contract.dp_knd_nm}}</td>
        <!-- 노출방법 => 타겟팅으로 수정 19.10.07 -->
        <td>{{parseDataType(contract.contract_imp)}}</td>
        <!-- 계약수 -->
        <td>
          <div class="data_wrap">
            {{parseDataType(contract.imp_cnt)}}
          </div>
        </td>
        <!-- 노출수 -->
        <td>
          <div class="data_wrap">
            {{parseDataType(contract.click_cnt)}}
          </div>
        </td>
        <!-- 클릭수 -->
        <td>
          <div class="data_wrap">
            {{contract.ctr.toFixed(2)}}
          </div>
        </td>
        <!--  CTR(%) -->
        <td>
          <div class="data_wrap">
            {{parseDataType(contract.view_cnt)}}
          </div>
        </td>
        <!-- VIEW -->
        <td>
          <div class="data_wrap">
            {{contract.vtr.toFixed(1)}}
          </div>
        </td>
        <!-- VTR(%) -->
        <td>
          <div class="data_wrap">
            {{campaignType !== 'PIP' ? parseDataType(contract.uv_cnt) : parseDataType(contract.skip_cnt)}}
          </div>
        </td>
        <!-- UV -->
        <td>
          <div class="data_wrap">
            {{parseData(contract.day_rate, 'rate')}}
          </div>
        </td>
        <!-- 진행률(%) -->
        <td>
          <div class="data_wrap">
            {{parseData(contract.imp_rate, 'rate')}}
          </div>
        </td>
        <!-- 달성률(%) -->
        <td v-if="campaignType === 'HIP'">
          <div class="data_wrap">
            {{parseDataType(contract.play_cnt)}}
          </div>
        </td>
        <!-- 재생수 -->
        <td>
          <div class="data_wrap">
            {{parseData(contract.play_sec_avg, 'rate')}}
          </div>
        </td>
        <!-- 평균재생(초) -->
        <td>
          <div class="data_wrap">
            {{parseData(contract.end_rate, 'rate')}}
          </div>
        </td>
        <!-- 재생완료(%) -->
        <td>
          <div class="data_wrap">
            {{parseData(contract.play_Q1_rate, 'rate')}}
          </div>
        </td>
        <!-- 재생Q1(%) -->
        <td>
          <div class="data_wrap">
            {{parseData(contract.play_Q2_rate, 'rate')}}
          </div>
        </td>
        <!-- 재생Q2(%) -->
        <td>
          <div class="data_wrap">
            {{parseData(contract.play_Q3_rate, 'rate')}}
          </div>
        </td>
        <!-- 재생Q3(%) -->
        <td>{{parseDataType(contract.budget_amt)}}</td>
        <!-- 총광고수 -->
      </tr>
      <tr>
        <td colspan="3" class="contract_total_text"><b>합계</b></td>
        <th>
          <div class="data_wrap">
            {{parseDataType(contractTotal.imp_cnt)}}
          </div>
        </th>
        <th>
          <div class="data_wrap">
            {{parseDataType(contractTotal.click_cnt)}}
          </div>
        </th>
        <th>
          <div class="data_wrap">
            {{contractTotal.ctr.toFixed(2)}}
          </div>
        </th>
        <th>
          <div class="data_wrap">
            {{parseDataType(contractTotal.view)}}
          </div>
        </th>
        <th>
          <div class="data_wrap">
            {{contractTotal.vtr.toFixed(1)}}
          </div>
        </th>
        <th>
          <div class="data_wrap">
            {{campaignType === 'PIP' ? parseDataType(contractTotal.skip) : ''}}
          </div>
        </th>
        <th>
          <div class="data_wrap">
            {{contractTotal.day_rate}}
          </div>
        </th>
        <th>
          <div class="data_wrap">
            {{contractTotal.imp_rate.toFixed(1)}}
          </div>
        </th>
        <th><div></div></th>
        <th><div></div></th>
        <th><div></div></th>
        <th><div></div></th>
        <th><div></div></th>
        <th>
          <div class="data_wrap">
            {{parseDataType(contractTotal.budget_amt)}}
          </div>
        </th>
      </tr>
    </tbody>
  </table>
</template>

<script>
  import { parseData } from '@/assets/func'
  export default {
    name: 'contractInterPlay',
    props: {
      campaignType: String,
      contractData: Array,
      contractTotal: Object,
      parseDataType: Function
    },
    data () {
      return {
        headers: [
          '광고상품',
          '타겟팅',
          '계약수',
          '노출수',
          '클릭수',
          'CTR(%)',
          'VIEW',
          'VTR(%)',
          'UV',
          '진행률(%)',
          '달성률(%)',
          '재생수',
          '평균재생(초)',
          '재생완료(%)',
          '재생Q1(%)',
          '재생Q2(%)',
          '재생Q3(%)',
          '총광고비'
        ]
      }
    },
    methods: {
      isMinter (n) {
        if (n === 11 && this.campaignType !== 'HIP') return false
        return true
      },
      parseData (data, key) {
        return parseData(data, key)
      }
    }
  }

</script>

<style scope>
  td {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// ContractInterPlay.vue?4d1831a2